import SampleImage2 from "../../../assets/images/sample2.jpg";
import IconDesc from "../my-course/IconDesc";
import {documents} from "../../../constants/icons";

function BundleCourseItem({
  className
}) {

  return (
    <div className={`${className || ""} carousel-block p-0 px-1`}>
      <div className="img-carousel">
        <img src={SampleImage2} className="img-fluid" />
      </div>
      <div className="desc-carousel">
        <h1>The Complete JavaScript Course 2022: From Zero to Expert!</h1>
        <p>Duis aute irure dolor in reprehenderit in volupt ae velit esse cillum dolore eu fu</p> 
        <IconDesc
          icon={documents}
          paraDesc="6 Lectures"
          className="mb-2"
        />
      </div>
    </div>
  );
}

export default BundleCourseItem;
